type RouteLocation = string | URL;

const pendingParentRevalidationTransitions = new Map<string, number>();

function normalizeRouteLocation(value: RouteLocation): string {
    if (typeof value !== 'string') {
        return normalizePathAndSearch(`${value.pathname}${value.search}`);
    }

    if (value.startsWith('http://') || value.startsWith('https://')) {
        const url = new URL(value);

        return normalizePathAndSearch(`${url.pathname}${url.search}`);
    }

    return normalizePathAndSearch(value.split('#', 1)[0]);
}

function normalizePathAndSearch(pathAndSearch: string): string {
    const withoutEmptyQuery = pathAndSearch.endsWith('?') ? pathAndSearch.slice(0, -1) : pathAndSearch;

    return withoutEmptyQuery.length > 1 ? withoutEmptyQuery.replace(/\/(?=$|\?)/, '') : withoutEmptyQuery;
}

function getTransitionKey(from: RouteLocation, to: RouteLocation): string {
    return `${normalizeRouteLocation(from)}\u0000${normalizeRouteLocation(to)}`;
}

function removePendingTransition(key: string): boolean {
    const pendingCount = pendingParentRevalidationTransitions.get(key);
    if (pendingCount === 1) {
        pendingParentRevalidationTransitions.delete(key);
    } else if (pendingCount !== undefined) {
        pendingParentRevalidationTransitions.set(key, pendingCount - 1);
    }

    return pendingCount !== undefined;
}

export function markBusinessAgentMfeParentRevalidationTransition(from: RouteLocation, to: RouteLocation) {
    const key = getTransitionKey(from, to);
    const pendingCount = pendingParentRevalidationTransitions.get(key);

    pendingParentRevalidationTransitions.set(key, pendingCount === undefined ? 1 : pendingCount + 1);
}

export function consumeBusinessAgentMfeParentRevalidationTransition(from: RouteLocation, to: RouteLocation): boolean {
    return removePendingTransition(getTransitionKey(from, to));
}

export function clearBusinessAgentMfeParentRevalidationTransition(from: RouteLocation, to: RouteLocation) {
    removePendingTransition(getTransitionKey(from, to));
}
